import { render, staticRenderFns } from "./MidiaTelaCheia.vue?vue&type=template&id=45b1f226&scoped=true"
import script from "./MidiaTelaCheia.vue?vue&type=script&lang=js"
export * from "./MidiaTelaCheia.vue?vue&type=script&lang=js"
import style0 from "./MidiaTelaCheia.vue?vue&type=style&index=0&id=45b1f226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1f226",
  null
  
)

export default component.exports